import React from 'react';
import Icon, { IconProps } from '../Icon';

const ServerStackIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 30 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.70801 7.12615H28.3567V3.65193H10.9622V2.49385H28.3567C28.9963 2.49385 29.5148 3.01234 29.5148 3.65193V7.12615C29.5148 7.76574 28.9963 8.28423 28.3567 8.28423H7.38245C7.49805 7.87625 7.60343 7.45304 7.70801 7.12615Z"
          fill="currentColor"
        />
        <path
          d="M10.9083 3.65193C11.2281 3.65193 11.4873 3.39268 11.4873 3.07289C11.4873 2.75309 11.2281 2.49385 10.9083 2.49385C10.5885 2.49385 10.3292 2.75309 10.3292 3.07289C10.3292 3.39268 10.5885 3.65193 10.9083 3.65193Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.16988 5.67495L8.33506 2.50977C8.56119 2.28364 8.92782 2.28364 9.15395 2.50977C9.38007 2.73589 9.38007 3.10252 9.15394 3.32865L5.60545 6.87714C5.37932 7.10327 5.01269 7.10327 4.78657 6.87714C4.7826 6.87318 4.77871 6.86918 4.77489 6.86513C4.73292 6.84228 4.69311 6.81383 4.65655 6.77973L3.24494 5.46339C3.01106 5.24529 2.99827 4.87889 3.21637 4.645C3.43446 4.41112 3.80087 4.39833 4.03475 4.61642L5.16988 5.67495Z"
          fill="currentColor"
        />
        <path
          d="M3.26501 11.3715V14.8458H28.3567V11.3715H3.26501ZM3.26501 10.2135H28.3567C28.9962 10.2135 29.5147 10.732 29.5147 11.3715V14.8458C29.5147 15.4854 28.9962 16.0039 28.3567 16.0039H3.26501C2.62542 16.0039 2.10693 15.4854 2.10693 14.8458V11.3715C2.10693 10.732 2.62542 10.2135 3.26501 10.2135Z"
          fill="currentColor"
        />
        <path
          d="M3.26501 18.7046V22.1788H28.3567V18.7046H3.26501ZM3.26501 17.5465H28.3567C28.9962 17.5465 29.5147 18.065 29.5147 18.7046V22.1788C29.5147 22.8184 28.9962 23.3369 28.3567 23.3369H3.26501C2.62542 23.3369 2.10693 22.8184 2.10693 22.1788V18.7046C2.10693 18.065 2.62542 17.5465 3.26501 17.5465Z"
          fill="currentColor"
        />
        <path
          d="M6.58145 1.38631C6.88196 1.49569 7.0369 1.82796 6.92752 2.12847C6.81815 2.42898 6.48587 2.58392 6.18536 2.47455C4.68282 1.92767 3.02144 2.70238 2.47456 4.20492C1.92768 5.70746 2.7024 7.36884 4.20494 7.91572C5.70748 8.4626 7.36886 7.68789 7.91574 6.18535C8.02511 5.88484 8.35739 5.7299 8.6579 5.83927C8.95841 5.94865 9.11335 6.28093 9.00397 6.58143C8.23834 8.68499 5.91241 9.76959 3.80885 9.00396C1.7053 8.23833 0.620694 5.91239 1.38633 3.80884C2.15196 1.70528 4.47789 0.62068 6.58145 1.38631Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default ServerStackIcon;
